import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AoSharedDataService } from '../service/ao-shared-data.service';

export const dataGuard: CanActivateFn = (route, state) => {
  const dataService = inject(AoSharedDataService);
  const router = inject(Router);
  if (dataService.isLoading) {
    dataService.requestedPage = state.url;
    router.navigate(['init']).then();
    return false;
  }
  return true;
};
